import { clsx } from '../../utils/cn.js';

const PLACEMENT = {
  top: {
    bubble: 'bottom-full left-1/2 mb-2 -translate-x-1/2',
    arrow: 'top-full left-1/2 -translate-x-1/2 border-x-[6px] border-x-transparent border-t-[6px] border-t-[#1acb12]',
  },
  bottom: {
    bubble: 'top-full left-1/2 mt-2 -translate-x-1/2',
    arrow:
      'bottom-full left-1/2 -translate-x-1/2 border-x-[6px] border-x-transparent border-b-[6px] border-b-[#1acb12]',
  },
};

/**
 * Tooltip visible al instante (sin el retardo del atributo `title` del navegador).
 */
export default function HoverTooltip({ label, placement = 'top', className, children }) {
  const pos = PLACEMENT[placement] ?? PLACEMENT.top;

  return (
    <span className={clsx('group/tooltip relative inline-flex max-w-full', className)}>
      {children}
      <span
        role="tooltip"
        className={clsx(
          'pointer-events-none absolute z-50 whitespace-nowrap',
          'opacity-0 scale-95 transition-[opacity,transform] duration-75 ease-out',
          'group-hover/tooltip:opacity-100 group-hover/tooltip:scale-100',
          'group-focus-within/tooltip:opacity-100 group-focus-within/tooltip:scale-100',
          pos.bubble
        )}
      >
        <span className="relative block rounded-md bg-[#1acb12] px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-900 shadow-[0_4px_24px_rgba(26,203,18,0.55)] ring-1 ring-white/30">
          {label}
          <span aria-hidden className={clsx('absolute h-0 w-0', pos.arrow)} />
        </span>
      </span>
    </span>
  );
}
